module.exports = __webpack_public_path__ + "img/JPG.85e7b08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advancedVersion/JPG.png
// module id = 8WJ2
// module chunks = 2 3 6 8 15 49